import { withMonogramContext } from "./MonogramContext";
import React, { useEffect, useState } from "react";
import MonogramSettingHeader from "./MonogramSettingHeader";
import { fileToImageDataURL, getEnvironmentConfig } from "../util/saveAPI";
import { getParamFromUrl } from "./util";

function MonogramUpload({ data, maxLength, setUploadedFile, uploadedFile }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const file = getParamFromUrl("file");
    if (file) {
      const initialUploadedFile = atob(file);
      setUploadedFile(initialUploadedFile);
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (uploadedFile) {
      urlParams.set("file", btoa(uploadedFile));
    } else {
      urlParams.delete("file");
    }
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [uploadedFile]);

  async function handleChange(evt) {
    const file = evt.target.files[0];

    setLoading(true);
    setError(null);
    try {
      const { screenshot_url } = getEnvironmentConfig();
      const imageDataUrl = await fileToImageDataURL(file);
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: `{"screenshot": "${imageDataUrl}"}`,
      };
      const response = await fetch(screenshot_url, options);
      if (response.status === 200) {
        const data = await response.json();
        setUploadedFile(data.Location);
        setLoading(false);
      } else {
        console.warn("Error uploading file:", response);
        setLoading(false);
        setError(new Error("Error uploading file, please try with different image"));
      }
    } catch (error) {
      console.warn("Error uploading file:", error);
      setLoading(false);
      setError(new Error("Error uploading file, please try with different image"));
    }
  }

  const sampleUrl = data.monogram_handwritten_sample;

  return (
    <div
      style={{ marginTop: uploadedFile ? "16px" : 0 }}
      className="monogram-setting-input-wrapper"
    >
      <MonogramSettingHeader
        title={
          sampleUrl ? (
            <>
              Turn your handwriting into embroidery by downloading{" "}
              <a target="_blank" href={sampleUrl}>
                this template
              </a>{" "}
              and uploading your photo here.
            </>
          ) : (
            "Upload Handwriting"
          )
        }
        subtitle={`Note: you can choose one solid thread color and draw up to ${maxLength} characters including simple symbols`}
      />
      <label htmlFor="monogram-upload-file" className={error && "input-error"}>
        {loading ? "Loading..." : "Upload Here"}
      </label>
      <input
        onChange={handleChange}
        id="monogram-upload-file"
        type="file"
        className="visually-hidden"
        accept="image/*"
      />
      {uploadedFile && (
        <div>
          <img
            className="monogram-uploaded-image"
            src={uploadedFile}
            style={{ width: "100%", height: "auto", objectFit: "contain", marginTop: "10px" }}
          />
          <button
            className="monogram-remove-upload"
            type="button"
            onClick={() => setUploadedFile(null)}
          >
            Remove
          </button>
        </div>
      )}
    </div>
  );
}

export default withMonogramContext(MonogramUpload);
